// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1f_kr","unreadBadge":"styles_unreadBadge__-Hxt_","modalContent":"styles_modalContent__d-w15","modal":"styles_modal__2oXQ7"};